export { default } from "./TabPanel.js";
export { default as tabPanelClasses } from "./tabPanelClasses.js";
export * from "./tabPanelClasses.js";